import * as React from 'react';

interface Props {
  title: string;
  description?: string;
  hero?: React.ReactNode;
}

export const Message: React.FC<Props> = (props) => {
  const { title, description, hero } = props;

  return (
    <div className="flex flex-col">
      <div className="grow flex flex-col text-center justify-center py-12">
        <div className="flex flex-col gap-3 justify-center">
          <div className="flex justify-center">{hero}</div>
          <h3 className="font-medium text-lg">{title}</h3>
          <p className="text-base">{description}</p>
        </div>
      </div>
    </div>
  );
};
Message.displayName = 'Message';
